import { atom } from "recoil";

export const studentPaymentState = atom({
  key: "studentPaymentKey",
  default: {
    invoices: [],
  },
});
